import { FC, useEffect, useState } from 'react'

import { useNavigate } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { BankAccount } from 'commons/types/DTO/bank/companyDetails/bankAccount'
import { TableDataQa } from 'commons/types/enums'
import { Layer, PageSectionPrimary, Table } from 'ui/components'
import { Button } from 'ui/components/Buttons'

import { handlerServerError } from '@orbit/errors'

import { CompanyBankAccountsTableProps } from './CompanyBankAccountsTableProps'
import { columns } from './columns'
import { useComponentsEssence } from './hooks/useComponentsEssence'
import { useFilterCompanyBankAccountsWebPage } from './hooks/useFilterCompanyBankAccountsWebPage'

export const CompanyBankAccountsTable: FC<CompanyBankAccountsTableProps> = (props) => {
  const {
    data: { id, bankAccounts, bankAccountsTotalCount }
  } = props
  const navigate = useNavigate()

  const [webPageData, setWebPageData] = useState({
    bankAccounts: bankAccounts,
    bankAccountsTotalCount: bankAccountsTotalCount
  })

  useEffect(() => {
    setWebPageData({
      bankAccounts: bankAccounts,
      bankAccountsTotalCount: bankAccountsTotalCount
    })
  }, [bankAccounts, bankAccountsTotalCount])

  const { routine: filterCompanyBankAccountsWebPage } = useFilterCompanyBankAccountsWebPage({
    onSuccess: async (_, result) => {
      await setWebPageData(result)
    },
    onError: (error) => handlerServerError(error)
  })

  const { changePagination, loading, tableState, startDeleting, Confirmation } = useComponentsEssence(
    id,
    filterCompanyBankAccountsWebPage,
    webPageData.bankAccountsTotalCount
  )

  return (
    <PageSectionPrimary
      face="outlined"
      title="Bank Accounts"
      anchor="bank-accounts"
      actions={
        <Button
          face="tertiary"
          onClick={() =>
            navigate({
              to: routes.bank.bankAccounts.create,
              search: { companyId: id, returnUrl: window.location.pathname + window.location.hash }
            })
          }
        >
          Add New
        </Button>
      }
    >
      <Confirmation />
      <Layer rounded shadowed stretch>
        <Table<BankAccount>
          dataQa={TableDataQa.BP_COMPANY_BANK_ACCOUNTS}
          columns={columns(startDeleting)}
          dataSource={webPageData.bankAccounts.map((el) => ({
            item: el
          }))}
          loading={loading}
          pagination={{
            page: tableState.page,
            size: tableState.size,
            onChange: changePagination,
            total: webPageData.bankAccountsTotalCount
          }}
        />
      </Layer>
    </PageSectionPrimary>
  )
}
